import { generatePath, useLoaderData, useLocation } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { ModelType } from '../../../../../common/enums.js';
import { internetSubscriptionsMsg, omaElisaForCompaniesMsg, t } from '../../../../../common/i18n';
import { AnalyticsEventOrigins } from '../../../../../common/utils/analyticsUtils';
import { getSubscriptionBreadcrumbName, getSubscriptionUrlId } from '../../../../../common/utils/subscriptionUtils.js';
import { BreadCrumbsWithTitle } from '../../../../../components/BreadCrumbsWithTitle/BreadCrumbsWithTitle.js';
import { OrderSubscriptionSelection } from '../../../../../components/OrderSubscriptionSelection/OrderSubscriptionSelection.js';
import type { SubscriptionUpdateLoaderData } from '../../../../../common/loaders';

export const BroadbandSubUpdatePath = () => {
  const { search } = useLocation();
  const { addOnRules, companyInfo, onlineModels, subscription } = useLoaderData() as SubscriptionUpdateLoaderData;
  const visibleOffers = companyInfo?.uiOptions?.visibleOffers;

  return (
    <>
      <BreadCrumbsWithTitle
        breadCrumbPaths={[
          { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
          { name: t.SEYV(internetSubscriptionsMsg), path: paths.PS_BROADBAND_SUBSCRIPTIONS },
          {
            name: getSubscriptionBreadcrumbName(subscription),
            path:
              generatePath(paths.PS_BROADBAND_SUBSCRIPTION, { subscriptionId: getSubscriptionUrlId(subscription) }) +
              search,
          },
          { name: t.IBZN('Mobile broadband update') },
        ]}
      />
      <OrderSubscriptionSelection
        addOnRules={addOnRules}
        isChangeOffer={true}
        showOnlyMinuteAndLegacy={false}
        onlineModels={onlineModels}
        onlineModelType={ModelType.MobileBroadband}
        subscription={subscription}
        visibleOffers={visibleOffers}
        hideYrityspuheUUSI={companyInfo?.hideYrityspuheUUSI}
        eventOrigin={AnalyticsEventOrigins.OMAELISA}
      />
    </>
  );
};
